import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaDiscord,
  FaEnvelope,
  FaGithub,
  FaLinkedin,
  FaMedium,
  FaTwitter,
} from 'react-icons/fa';

const FooterSection = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="sm:!block">
      <div
        className="flex justify-between items-center sm:block sm:mb-4 cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <h3 className="text-md sm:text-lg font-semibold text-gray-800">{title}</h3>
        <span className="sm:hidden text-xl">{open ? '−' : '+'}</span>
      </div>
      <div className={`${open ? 'block' : 'hidden'} sm:block`}>
        {children}
      </div>
    </div>
  );
};

function Footer() {
  return (
    <footer className="bg-gradient-to-b from-indigo-50 to-white border-t border-gray-200 text-gray-700 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div>
            <div className="flex items-center">
              <h2 className="text-xl font-bold text-gray-800">CelystikHub</h2>
              <span className="ml-2 bg-indigo-600 text-white text-xs px-2 py-0.5 rounded-full">BETA</span>
            </div>
            <p className="mt-4 text-gray-600">
              A decentralized infrastructure for innovators and builders to collaborate and build the future of web3.
            </p>
            <div className="mt-4 flex space-x-4">
              <a href="https://x.com/celystik535" target="_blank" rel="noreferrer" className="hover:text-indigo-600">
                <FaTwitter size={18} />
              </a>
              <a href="https://github.com/Celystik-Labs" target="_blank" rel="noreferrer" className="hover:text-indigo-600">
                <FaGithub size={18} />
              </a>
              <a href="https://www.linkedin.com/company/celystik-labs" target="_blank" rel="noreferrer" className="hover:text-indigo-600">
                <FaLinkedin size={18} />
              </a>
              <a href="https://medium.com/@celystik-labs" target="_blank" rel="noreferrer" className="hover:text-indigo-600">
                <FaMedium size={18} />
              </a>
              <a href="https://discord.gg/UTGnrmMU" target="_blank" rel="noreferrer" className="hover:text-indigo-600">
                <FaDiscord size={18} />
              </a>
            </div>
          </div>

          {/* Sections as accordions */}
          <FooterSection title="Resources">
            <ul className="space-y-2 mt-2">
              <li><Link to="https://celystikhub.gitbook.io/www.celystikhub-gitbook.com" className="hover:text-indigo-600">Documentation</Link></li>
            </ul>
          </FooterSection>

          <FooterSection title="Platform">
            <ul className="space-y-2 mt-2">
              <li><Link to="/projects" className="hover:text-indigo-600">Projects</Link></li>
              <li><Link to="/innovators" className="hover:text-indigo-600">Innovators</Link></li>
              <li><Link to="/portfolio" className="hover:text-indigo-600">Portfolio</Link></li>
            </ul>
          </FooterSection>

          <FooterSection title="Company">
            <ul className="space-y-2 mt-2">
              <li><Link to="https://www.celystik.io" className="hover:text-indigo-600">About Us</Link></li>
              <li><Link to="https://www.celystik.io" className="hover:text-indigo-600">Careers</Link></li>
              <li><Link to="https://celystikhub.gitbook.io/www.celystikhub-gitbook.com" className="hover:text-indigo-600">Terms</Link></li>
              <li>
                <a href="mailto:info@celystik.io" className="flex items-center hover:text-indigo-600">
                  <FaEnvelope size={14} className="mr-2" /> Contact Us
                </a>
              </li>
            </ul>
          </FooterSection>
        </div>

        <div className="mt-10 border-t border-gray-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-500">
          <div className="flex flex-col sm:flex-row items-center gap-2">
            <p>&copy; {new Date().getFullYear()} CelystikHub. All rights reserved.</p>
            <span className="hidden sm:inline">•</span>
            <p>
              Powered by{" "}
              <a href="https://www.celystik.io" target="_blank" rel="noreferrer" className="text-indigo-600 hover:text-indigo-800 font-medium">
                Celystik Labs
              </a>
            </p>
          </div>
          <a href="https://etherscan.io" target="_blank" rel="noreferrer" className="text-gray-600 hover:text-indigo-600">
            View Contract
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
